import { API } from "aws-amplify";
import config from "../config.json";
import { OffLineAPI } from "../offline-auth/api";

var _API = config.isOffline ? OffLineAPI : API;

export function getUsers(name, searchKey, token, limit, skip = 0) {
  let query = `consultRole=${name}`;
  query +=
    token && token !== null && token !== ""
      ? `&token=${JSON.stringify(token)}`
      : "";
  query += searchKey && searchKey != null && searchKey != "" ? searchKey : "";
  query += limit ? `&limit=${limit}` : `&limit=10`;
  query += `&skip=${skip}`;
  return _API.get("users", `/consultantList?${query}`);
}
export function getClinics() {
  let query = `consultRole=clinic`;
  //  query += limit ? `&limit=${limit}` : `&limit=10`
  return _API.get("users", `/userslist?${query}`);
}
export function getUserDetails(id) {
  return _API.get("users", `/userdetails?userId=${id}`);
}

export function updatProfilePic(body) {
  return _API.post("users", `/profilepic`, { body });
}
export function createPatient(body) {
  return _API.post("users", `/createpatient`, { body });
}

export function updateProfile(body) {
  return _API.put("users", `/updateconsultuser`, { body });
}
export function deletePatient(body) {
  return _API.post("users", `/deleteuser`, { body });
}

export function adminDashboard() {
  return _API.get("admin", `/admindashboard`);
}
export function adminUserReport() {
  return _API.get("admin", `/adminuserreport`);
}
export function clinicUserReport() {
  return _API.get("admin", `/corporatedashboard`);
}
export function adminAppointmentReport() {
  return _API.get("admin", `/adminappointmentreport`);
}

export function clinicAppointmentReport() {
  return _API.get("admin", `/corporateappointmentreport`);
}
export function createUser(body) {
  if (config.isOffline === true) {
    return _API.post("admin", `/usersignup`, { body });
  } else {
    return _API.post("admin", `/adminuser`, { body });
  }
}

export function adminDoctorReport(stateName, city, from, to, token, limit) {
  let query = `stateName=${stateName}&city=${city}&from=${from}&to=${to}`;
  query +=
    token && token !== "" && token !== null
      ? `&token=${JSON.stringify(token)}`
      : "";
  query += limit ? `&limit=${limit}` : `&limit=10`;
  return _API.get("admin", `/admindoctorreport?${query}`);
}

export function adminAppointmentReports(role, from, to, token, limit) {
  let query = `role=${role}&from=${from}&to=${to}`;
  query +=
    token && token !== "" && token !== null
      ? `&token=${JSON.stringify(token)}`
      : "";
  query += limit ? `&limit=${limit}` : `&limit=10`;
  return _API.get("admin", `/adminappointmentreportbyrole?${query}`);
}
export function updateUser(id, body) {
  return _API.put("admin", `/updateuser/${id}`, { body });
}

export function deleteUser(body) {
  return _API.post("admin", `/deleteuser`, { body });
}
export function getDoctorUploadFiles() {
  return _API.get("users", `/doctoruploadlist`);
}
export function getDoctorFiles(id) {
  return _API.get("users", `/doctoruploadlist?userId=${id}`);
}

export function deletewaitingroomupload(body) {
  return _API.post("users", `/deletewaitingroomupload`, { body });
}

export function patientsignup(body) {
  return _API.post("users", `/patientsignup`, { body });
}

export function usersignup(body) {
  return _API.post("users", `/createuser`, { body });
}

export function createroom(body) {
  // let body = {
  // roomName: 'testfordemo',
  // roomOptions: {
  //     inputLimit : 10,
  //     participantLimit : 10,
  // },
  // roomType: 'C',
  // userEmail: 'venkatesh.t@peoplelinkvc.com',
  // expireAt: 1639035099641

  // }
  return _API.post("admin", `/createroom`, { body });
}
export function login(body) {
  return _API.post("users", `/login`, { body });
}

export function currentsession() {
  return _API.get("users", `/currentsession`);
}

export function currentuserinfo(userId = null) {
  let path = config.isOffline
    ? `/currentuserinfo`
    : `/currentuserinfo?sub=${userId}`;
  // return _API.get("users", `/currentuserinfo?sub=${userId}`);
  console.log("pathh ========", path);
  return _API.get("users", path);
}

export function getallClinics(qr = null) {
  let query = `consultRole=clinic`;
  if (qr !== null) {
    query += `&${qr}`;
  }
  //  query += limit ? `&limit=${limit}` : `&limit=10`
  return _API.get("users", `/listallclinics?${query}`);
}

export function changepasword(body) {
  return _API.put("users", `/changepassword`, { body });
}

export function verifyuser(body) {
  return _API.post("admin", `/verifyuser`, { body });
}
export function forgotPassword(body) {
  return _API.post("users", `/sendotp`, { body });
}
export function forgotPasswordSubmit(body) {
  return _API.post("users", `/validateotp`, { body });
}

export function deletefiles(body) {
  return _API.post("users", `/deletefile`, { body });
}

export function getAllAdmins() {
  let query = `consultRole=corporate`;
  //  query += limit ? `&limit=${limit}` : `&limit=10`
  return _API.get("users", `/listallcorporates?${query}`);
}

export function getDoctorList(
  name,
  filterDate,
  from,
  fromTime,
  to,
  days,
  token,
  clinicId,
  limit,
  skip,
  searchKey = ''
) {
  let query = filterDate
    ? `consultantType=${name}&filterDate=${filterDate}`
    : `consultantType=${name}`;
  query += `&limit=${limit}&skip=${skip}&from=${from}&fromTime=${fromTime}&to=${to}&days=${days}&corporateId=${clinicId}`;
  query +=
    token && token !== null && token !== ""
      ? `&token=${JSON.stringify(token)}`
      : "";
  query += "&consultRole=consultant";
  query += searchKey && searchKey !== '' ? `&searchKey=${searchKey}` : '';

  return _API.get("users", `/consultantTypeList?${query}`);
}

export function checkDomain(username, domain) {
  // console.log("domain ==== ", domain);
  if (
    domain &&
    domain.subDomains &&
    domain.subDomains[0] &&
    domain.hostname !== "localhost"
  ) {
    let body = { username, domain: domain.subDomains[0] };
    return _API.post("users", `/domainconfirmation`, { body });
  } else {
    return { status: true };
  }
}

export function deleteProfilePic(body) {
  return _API.post("users", "/deleteprofile", { body });
}
export function getDomainDetials(domain) {
  return _API.get("admin", `/listdomain?subdomain=${domain}`);
}

export function getStipeDetials(userId) {
  return _API.get("admin", `/liststripe/${userId}`);
}

export function updateStripeDetails(body) {
  return _API.post("admin", `/stripecreate`, { body });
}

export function getPoolDetials(userId) {
  return _API.get("admin", `/listpool/${userId}`);
}

export function updatePoolDetails(body) {
  return _API.post("admin", `/poolcreate`, { body });
}

export function updateDomainDetails(domain, body) {
  return _API.post("admin", `/stripe/${domain}`, { body });
}
export function deleteStripeDetails(subdomain) {
  return _API.del("admin", `/deletestripe?subdomain=${subdomain}`, {});
}

export function getDepartmentList() {
  return _API.get("users", `/departmentlist`);
}
export function getSpecializationList() {
  return _API.get("users", `/specializationlist`);
}

export function deleteLogo(body) {
  return _API.del("admin", `/deletelogo`, { body });
}

export function getDomainData(subdomain) {
  return new Promise((resolve, reject) => {
    fetch(`${config.usersGateway.URL}/domainlist/${subdomain}`)
      .then((res) => res.json())
      .then(
        (result) => {
          resolve(result);
        },
        (error) => {
          console.log("error in domain api === ", error);
          resolve(null);
        }
      );
  });
}

export function getFrequentConsultations(id) {
  return new Promise((resolve, reject) => {
    fetch(`${config.usersGateway.URL}/frequsers/${id}`)
      .then((res) => res.json())
      .then(
        (result) => {
          resolve(result);
        },
        (error) => {
          console.log("error in domain api === ", error);
          resolve(null);
        }
      );
  });
}

export function getFrequentUsers(id) {
  // return new Promise((resolve, reject) => {
  //   fetch(`${config.usersGateway.URL}/freqconsultants/${id}`)
  //     .then((res) => res.json())
  //     .then(
  //       (result) => {
  //         resolve(result);
  //       },
  //       (error) => {
  //         console.log("error in domain api === ", error);
  //         resolve(null);
  //       }
  //     );
  // });
  return _API.get("users", `/freqconsultants/${id}`);
}

export function getConsultantType() {
  return _API.get("users", "/consultantdata?request=consultantcat");
}

export function getCosultantSpecification() {
  return _API.get("users", "/consultantdata?request=consultantspec");
}

export function getConsultanDesignation() {
  return _API.get("users", "/consultantdata?request=designation");
}

export function getConsultantCount(corporateId) {
  return _API.get("users", `/consultantcount?corporateId=${corporateId}`);
}

export function getLicenseStatus(phone, subdomain = "") {
  console.log("body ========", phone);
  let query = `?phone=${phone}`;
  // subdomain !== '' ? query += `&subdomain=${subdomain}` : ""
  if (subdomain !== "") {
    query += `&subdomain=${subdomain}`;
  }
  return _API.get("users", `/getunpaidlicenses${query}`);
}

export function getUserDataByphoneSubdomain(query){
  return _API.get('users', `/getUserByPhoneAndSubdomain${query}`)
}

export function getCorporateLicenseStatus(username, subdomain, role) {
  console.log("body ========", username);
  return _API.get(
    "users",`/getcorporatepayment?username=${username}&subdomain=${subdomain}&role=${role}`
  );
}

export function contactDetail(body) {
  // console.log('body is', body)
  return _API.post("users", `/support`, { body });
}

export function getContactDetail(id) {
  return _API.get("users", `/support?userId=${id}`);
}

export function helpSupport(domain, body) {
  return _API.post("users", `/mailtocare?subdomain=${domain}`, { body });
}

export function getHelpSupport(domain) {
  return _API.get("users", `/support?subdomain=${domain}`);
}

export const getLicenseDetails = (body) => {
  return _API.post("users", `/licensedetails`, {body});
};

export const getUserDetailsDelete = (id) => {
  return _API.get("admin", `/getCount?userId=${id}`);
};

export const createFreeUser = (body) => {
  return _API.post("admin", "/freelicense", { body });
};
